import type { Monaco } from "../_monaco";

/**
 * Makes the Tab key to blur the editor instead of inserting a tab character.
 *
 * Returns a cleanup function to remove event listeners and actions when no longer needed.
 */
export function preventTabulation(monaco: typeof Monaco, editor: Monaco.editor.IStandaloneCodeEditor): VoidFunction {
	const disposable = editor.addAction({
		id: "blur-on-tab",
		label: "Blur on Tab",
		keybindings: [monaco.KeyCode.Tab, monaco.KeyMod.Shift | monaco.KeyCode.Tab],
		keybindingContext: "editorTextFocus && !editorTabMovesFocus",
		run: () => {
			if (document.activeElement instanceof HTMLElement) {
				document.activeElement.blur();
			}
		},
	});

	return () => {
		disposable.dispose();
	};
}
